import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';

type UIBlockerErrorProps = {
  errorText: string;
  onClick: () => void;
};
export const UIBlockerError = ({
  onClick,
  errorText,
}: UIBlockerErrorProps): JSX.Element => (
  <FlexBox
    style={{
      position: 'absolute',
      height: '100%',
      width: '100%',
      paddingBottom: '30px',
    }}
    alignItems="flex-end"
    justifyContent="center"
    gap="200"
    onClick={onClick}
  >
    <Text.Paragraph
      variant="1"
      color="error"
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <Icon name="exclamation" color="error" style={{ marginRight: '8px' }} />
      {errorText}
    </Text.Paragraph>
  </FlexBox>
);
